import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'
import { colors } from '@/styles/designTokens'

export const Backdrop = styled(Box)<{ isEdit: boolean }>(({ theme, isEdit }) => ({
	position: 'fixed',
	inset: 0,
	backgroundColor: 'rgba(0,0,0,0.25)',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	zIndex: 1300,
	...(!isEdit && {
		[theme.breakpoints.down('md')]: {
			alignItems: 'flex-end',
			justifyContent: 'flex-start',
		},
	}),
}))

export const Card = styled(Box, { shouldForwardProp: (prop) => prop !== 'isEdit' })<{
	width: number
	isEdit: boolean
}>(({ theme, width, isEdit }) => ({
	position: 'relative',
	backgroundColor: colors.surfaceWhite,
	borderRadius: '16px',
	width: `${width}px`,
	maxWidth: '100%',
	maxHeight: '90vh',
	overflow: 'hidden',
	display: 'flex',
	flexDirection: 'column',
	boxShadow:
		'0px 1px 3px rgba(0,0,0,0.2), 0px 2px 1px rgba(0,0,0,0.12), 0px 1px 1px rgba(0,0,0,0.14)',
	margin: '16px',
	...(!isEdit && {
		[theme.breakpoints.down('md')]: {
			borderRadius: '16px 16px 0 0',
			width: '100%',
			maxWidth: '100%',
			margin: 0,
			maxHeight: '85vh',
		},
	}),
}))

export const HeaderBar = styled(Box)({
	display: 'flex',
	alignItems: 'center',
	gap: '12px',
	padding: '0 24px',
	height: '72px',
	borderBottom: `1px solid ${colors.divider}`,
	flexShrink: 0,
})
